import { StatusBadge, STATUS_BADGES } from "@/shared/components/StatusBadge";

/** Marks a rule's saved action as switched off. */
export function PausedBadge() {
  return <StatusBadge status={STATUS_BADGES.ingestionRule.paused} />;
}
